export function downloader(data, type, name) {
  console.log('download ' + name + '(' + type + ')')
  console.log(data)
  let blob = new Blob([data], { type })
  BlobDownloader(blob,name)
}
function BlobDownloader(blob, name) {
  let url = window.URL.createObjectURL(blob)
  downloadURI(url, name)
  window.URL.revokeObjectURL(url)
}

function downloadURI(uri, name) {
  let link = document.createElement("a")
  link.download = name
  link.href = uri
  link.click()
}